export const energyConstants = {
  TODAY_STATUS_REQUEST: "ENERGY_TODAY_STATUS_REQUEST",
  TODAY_STATUS_SUCCESS: "ENERGY_TODAY_STATUS_SUCCESS",
  TODAY_STATUS_FAILURE: "ENERGY_TODAY_STATUS_FAILURE",
  DAILY_STATUS_REQUEST: "ENERGY_DAILY_STATUS_REQUEST",
  DAILY_STATUS_SUCCESS: "ENERGY_DAILY_STATUS_SUCCESS",
  DAILY_STATUS_FAILURE: "ENERGY_DAILY_STATUS_FAILURE",
  DETAIL_REQUEST: "ENERGY_DETAIL_REQUEST",
  DETAIL_SUCCESS: "ENERGY_DETAIL_SUCCESS",
  DETAIL_FAILURE: "ENERGY_DETAIL_FAILURE",
  USED_REQUEST: "USED_REQUEST",
  USED_SUCCESS: "USED_SUCCESS",
  USED_FAILURE: "USED_FAILURE",
  SET_USAGE_FREQUENCY: "SET_USAGE_FREQUENCY",
  SET_DETAIL_ITEM: "SET_DETAIL_ITEM",
  TOGGLE_EXPANDER: "TOGGLE_EXPANDER",
  TIMELINE_REQUEST: "APPLIANCES_TIMELINE_REQUEST",
  TIMELINE_SUCCESS: "APPLIANCES_TIMELINE_SUCCESS",
  TIMELINE_FAILURE: "APPLIANCES_TIMELINE_FAILURE"
};
